import {members} from "./members";
import {Box, Button, Stack, Typography} from "@mui/material";
import {MemberCard} from "./MemberCard";
import {PATH} from "../../routing/routes";
import {useNavigate} from "react-router";

const Team = () => {
    const navigate = useNavigate();

    const handleClickContact = () => {
        navigate(PATH.CONTACT);
    };

    return (
        <Stack direction="column" alignItems="center">
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: 3,
                    mt: 4,
                    mb: 4,
                }}
            >
                {members.map((member) => (
                    <MemberCard key={member.name} member={member}/>
                ))}
            </Box>
            <Stack direction="column" alignItems="center" gap="20px" padding="20px">
                <Typography variant="h6">
                    Vrei să lucrezi alături de noi?
                </Typography>
                <Button variant="contained" onClick={handleClickContact}>
                    Contactează-ne acum!
                </Button>
            </Stack>
        </Stack>


    )
}

export default Team;